import React from 'react';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { playaudio, getaudio } from '../../common/functions';
import './postgame.css';
export function PostGame(props) {
    var a = props.guessed.map(function (element) {
        var icon;
        if (element.guessedCorrect)
            icon = React.createElement(CheckIcon, { sx: { color: 'green' } });
        else
            icon = React.createElement(ClearIcon, { sx: { color: 'red' } });
        return (React.createElement("div", { key: element.id },
            React.createElement("button", { onClick: function () { return playaudio(getaudio(element.audio)); } },
                React.createElement(VolumeUpIcon, { sx: { fontSize: 20 } })),
            React.createElement("div", null, element.word),
            React.createElement("div", null, element.wordTranslate),
            icon));
    });
    return (React.createElement("div", { className: "postgame" },
        a,
        React.createElement("button", { onClick: props.reset }, "RESET")));
}
